_getCart = async function () {
    const result = await fetch("/cart.json");

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

_getInStock = async function (product_id) {
    const result = await fetch("https://api-shop.dior.com.au/hk/check.php?key=MmuywGrabzrNsHhEiaCCeWsASrNnJ77D8AnvtGMBq4mLrmLKaNvJEW9cCw4mVAg8&type=product_stock_list&product_id=" + product_id);

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

_getGiftEnTranslations = async function () {
    const result = await fetch("https://api-shop.dior.com.au/hk/translations.php?key=DWcDvZWPmEV3HPBYdZW53ukrRDrJyfts&type=translations_get", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(window.constants.idVariantMap)
    });

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

_checkDiscountGwp = async function (code, ids = []) {
    const result = await fetch("https://api-shop.dior.com.au/hk/discounts_tests.php?key=dsg7L9EGgJ86DP&type=check_discount", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            discount: code,
            ids: ids,
            customer_id: window.theme.customer_id,
            cart: window.getCartCache()
        })
        
    });

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

_addItem = async function (variantId, quantity, theProperties = {}) {

    // console.log("adding to cart: ", variantId, quantity, theProperties);

    if (theProperties === {}) {
        var result = await fetch("/cart/add.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity
            })
        })
    } else {
        var result = await fetch("/cart/add.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity,
                properties: theProperties
            })
        })
    }

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

async function _setNote(note) {
    const result = await fetch("/cart/update.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            note: note
        })
    });

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

async function _clearCart() {
    const result = await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
            "Accept": "application/json"
        }
    });

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

async function _getProduct(handle) {
    const result = await fetch(`/products/${handle}.json`, {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    });

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

async function _setCartAttributes(attributes = {}) {
    const result = await fetch("/cart/update.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            attributes
        })
    });

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

async function _updateItem(data) {

    // console.log("cart update: ",JSON.stringify(data));

    const result = await fetch("/cart/change.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(data),
    });

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

async function _removeItem(data) {
    const result = await fetch("/cart/change.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            ...data,
            quantity: 0
        })
    });

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

async function _checkForNeedEmptyCart(cart = false) {
    var clearCart = true;
    var response = null;

    if (!cart) {
        await _getCart().then(async function (cartResponse) {
            window.updateCartCache(cartResponse);
            response = cartResponse;
        });
    } else {
        response = cart;
    }

    if (response && response.items.length) {
        for (let i = 0; i <= response.items.length - 1; i++) {
            if (!window.constants.gwpArray.includes(response.items[i].id)) {
                clearCart = false;
            }
        }

        if (clearCart) { 
            localStorage.removeItem("discount_data");
            localStorage.removeItem("discount");
            localStorage.removeItem("gift_message_added");
            localStorage.removeItem("gift_message");
            
            if (window.getCodeStack()) {
                window.clearCodeStack();
            }

            await _clearCart().then(async function (response) {
                return true;
            });
        }
    }


    return false;
}

async function updateItemById(lineItemId, newQuantity, newProperties = {}) {
    return await _updateItem({
        id: lineItemId,
        quantity: newQuantity,
        properties: newProperties
    });
}


function doesCartHaveGwp(type = false) {
    var cart = window.getCartCache();

    if (type && cart && cart.items.length >= 1) {

        for (let i = 0; i <= cart.items.length - 1; i++) {

            for (let j = 0; j <= window.constants.gwp.length - 1; j++) {

                if (cart.items[i].id === window.constants.gwp[j].id && type === window.constants.gwp[j].name ) {
                    return cart.items[i].key;
                }
            }
        }
    }

    return false;
}


function doesCartHaveSample(code = false) {
    var cart = window.getCartCache();

    if (code && cart && cart.items.length >= 1) {
        for (let i = 0; i <= cart.items.length - 1; i++) {
            for (let j = 0; j <= window.constants.samples.length - 1; j++) {
                if (cart.items[i].id === window.constants.samples[j].id && code === window.constants.samples[j].code) {
                    return cart.items[i].key;
                }
            }
        }
    }

    return false;
}

async function calculateGwpTotal(getCart = false) {
    var response = null;
    var totalPrice = 0;
    var cart = null;

    if (getCart) {
        await _getCart().then(async function (cartResponse) {
            window.updateCartCache(cartResponse);
            cart = cartResponse;
        });

        cart = getCart;
    }

    if (cart === null) {
        cart = window.getCartCache();
    }

    if (cart) {
        for (let i = 0; i <= cart.items.length - 1; i++) {
            if (!window.constants.gwpArray.includes(cart.items[i].id)) {
                totalPrice = totalPrice + cart.items[i].line_price;
            }
        }
    }

    return totalPrice;
}


async function calculateGwpTotalGiftType(getCart = false) {
    var response = null;
    var totalPrice = 0;
    var cart = null;

    if (getCart) {
        await _getCart().then(async function (cartResponse) {
            window.updateCartCache(cartResponse);
            cart = cartResponse;
        });

        cart = getCart;
    }

    if (cart === null) {
        cart = window.getCartCache();
    }

    if (cart) {
        for (let i = 0; i <= cart.items.length - 1; i++) {
            if (cart.items[i].product_type !== "Gift Set" && !window.constants.gwpArray.includes(cart.items[i].id)) {
                totalPrice = totalPrice + cart.items[i].line_price;
            }
        }
    }

    return totalPrice;
}


window.inStock = async function (product_id) {
    return await _getInStock(product_id);
}

window.checkDiscountGwp = async function (code, ids = []) {
    return await _checkDiscountGwp(code, ids);
}

window.calcCartTotal = async function (code) {
    return await calculateGwpTotal();
}

// Update item in the cart
window.updateItem = async function (id, quantity, properties) {
    var attempt = await updateItemById(id, quantity, properties).then(async function (response) {
        window.updateCartCache(response);
        // console.log("response", response);
        await _checkForNeedEmptyCart(response).then(async function () {
            return await attempt;
        });
    });

    return await attempt;
}

// Set cart attributes
// Unlike line item properties and the cart note, merchants cannot see cart attributes. These attributes are largely for scripts and apps to store/read extra information about the order.
window.setCartAttributes = async function (attributes) {
    return await _setCartAttributes(attributes);
}

// Gets product json by handle
window.getProduct = async function (handle) {
    return await _getProduct(handle);
}

// Clear the cart
window.clearCart = async function () {
    return await _clearCart();
}

// Set note on the cart
window.setCartNote = async function (note) {
    return await _setNote(note);
}

// Remove item from the cart by ID
window.removeItemById = async function (theId) {
    var attempt = await _removeItem({ id: theId }).then(async function (response) {
        window.updateCartCache(response);
        await _checkForNeedEmptyCart(response).then(function () {
            return attempt;
        })
    });

    return attempt;
}

// Remove item from the cart by index
window.removeItemByLine = async function (oneBasedLineIndex) {
    var attempt = await _removeItem({ line: oneBasedLineIndex }).then(async function (response) {
        window.updateCartCache(response);
        await _checkForNeedEmptyCart(response).then(function () {
            return attempt;
        });
    });

    return attempt;
}

// Define custom max quantities
// Add variant ID and return the max quantity 
getQtyTotal = function(item) {
    switch (item.id) {

        // case 34919516209304:
        //     return 2;
        // break;

        default:
            return 1;
        break;

    }
}

// Return cart contents
window.getCart = async function () {
    await _getCart().then(async function (response) {
        window.updateCartCache(response);
        
        let gwpTotal = await calculateGwpTotal(response);

        var hasGift = false;
        var hasMaisonGift = false;
        var giftKey = null;
        var maison = false; 

        var canJulyGwp = false; // check for the july gwp that adds three products

        var hasMaisonProducts = false; // to check if the cart has no mcd products
        var hasMaisonCard = false; // check if the mcd card is in the cart

        var mcd2020inCart = false;

        // GWP for Aug 1
        var makeupCount = 0;
        var hasBrowCard = false;

        // BeautyEx code
        var hasBeauty = false;
        var beautyProducts = [];
        var beautyCount = 0;
        var canBeauty = false;

        // New September
        var hasGwp1 = false;
        var canGwp1 = false;

        var hasGwp2 = false;
        var canGwp2 = false;

        var hasGwp3 = false;
        var canGwp3 = false;

        var hasGwp4 = false;
        var canGwp4 = false;
     

        // 510-hk-same-first-purchase-random-discount-code-as-au
        var hasGwp5 = false;
        var canGwp5 = false;

        // CTCOSMO | 23 Sep - 31 Oct
        var hasGwp6 = false;
        var canGwp6 = true; // No restrictions on this code
        var hasGwp7 = false;
        var canGwp7 = true; // No restrictions on this code                
        var hasGwp8 = false;
        var canGwp8 = true; // No restrictions on this code   



        var hasGwpOctXMAS800 = false;
        var canGwpOctXMAS800 = false;
        var hasGwpOctGOLDENIGHTS = false;
        var canGwpOctGOLDENIGHTS = false;
        var hasGwpOctROSE1 = false;
        var canGwpOctROSE1 = false;
        var hasGwpOctROSE2 = false;
        var canGwpOctROSE2 = false;
        var hasGwpOctROSE3 = false;
        var canGwpOctROSE3 = false;
        var hasGwpOctPRESTIGE1 = false;
        var canGwpOctPRESTIGE1 = false;
        var hasGwpOctPRESTIGE2 = false;
        var canGwpOctPRESTIGE2 = false;
        var hasGwpOctPRESTIGE3 = false;
        var canGwpOctPRESTIGE3 = false;
        var hasGwpOctLOVEROSE1 = false;
        var canGwpOctLOVEROSE1 = false;
        var hasGwpOctLOVEROSE2 = false;
        var canGwpOctLOVEROSE2 = false;
        var hasGwpOctLOVEROSE3 = false;
        var canGwpOctLOVEROSE3 = false;         


        var hasGwpOct1 = false;
        var canGwpOct1 = false;

        var hasGwpOct2 = false;
        var canGwpOct2 = false;
        
        var hasGwpOct3 = false;
        var canGwpOct3 = false; 

        // BOCOM | 1 Sep - 31 Dec
        var hasBOCOM = false;
        var canBOCOM = false;


        // By inscoder 
        // Upon purchase of any Xmas Staycation Items | 26 Oct – 30 Nov | By inscoder
        var eligibleGwpOctNovXmasStaycation = ["C018473665","C019473772","C019473999","C018473999","C018800089","C018800549","C018900001","F000298649","F000298767","F000298997","C099692565","C018600001","C018700353","C018500070","C018500071","C018500072","C018500073","C014300040","C014300640"];
        var hasGwpOctNovXmasStaycation = false;
        var canGwpOctNovXmasStaycation = false; // to check if the cart has Xmas Staycation products

        // JAD EDP SPL MINIA FB 5ML INT18 | Any purchase of any 2 J'adore products | Duration 26 Oct - 31 Dec | By inscoder
        var jadoreCount = 0;
        var hasGwpNovDec1A = false;
        var hasGwpNovDec1B = false;
        var canGwpNovDec1 = false; // to check if the cart has 2 J'adore products

        // // HK ePop up Xmas Invitation Card | Duration 1 Nov - 15 Dec | By inscoder
        // var eligibleSKUInvitCard = ["F361524609","F071524009","F032624889","C099600486","F068524009","F078524009","C099600455","C400000807","C400000847"];
        // var hasGwpNovDecInvitCard = false;
        // var canGwpNovDecInvitCard = false;
        
        // promocode MCDHOME | Duration 16 - 31 Dec | By inscoder
        var hasGwpDecMCDHOME1 = false;
        var canGwpDecMCDHOME1 = false;
        var hasGwpDecMCDHOME2 = false;
        var canGwpDecMCDHOME2 = false;
        var hasGwpDecMCDHOME3 = false;
        var canGwpDecMCDHOME3 = false;

        // promocode HOLIDAY | Duration 1 - 31 Dec | By inscoder
        var hasGwpDecHOLIDAY1 = false;
        var canGwpDecHOLIDAY1 = false;
        var hasGwpDecHOLIDAY2 = false;
        var canGwpDecHOLIDAY2 = false;

        // promocode ILOVEXMAS | Duration 11 Nov - 24 Dec | By inscoder
        var hasGwpNovDecILOVEXMAS1 = false;
        var canGwpNovDecILOVEXMAS1 = false;
        var hasGwpNovDecILOVEXMAS2 = false;
        var canGwpNovDecILOVEXMAS2 = false;
        var hasGwpNovDecILOVEXMAS3 = false;
        var canGwpNovDecILOVEXMAS3 = false;

        // promocode LOVEROUGE | Duration 15 Oct - 31 Nov | By inscoder
        var hasGwpOctNovLOVEROUGE1 = false;
        var canGwpOctNovLOVEROUGE1 = false;
        var hasGwpOctNovLOVEROUGE2 = false;
        var canGwpOctNovLOVEROUGE2 = false;
        var hasGwpOctNovLOVEROUGE3 = false;
        var canGwpOctNovLOVEROUGE3 = false;

        // promocode XMASCARE | Duration 1 Dec - 24 Dec | By inscoder
        var hasGwpDecXMASCARE1 = false;
        var canGwpDecXMASCARE1 = false;
        var hasGwpDecXMASCARE2 = false;
        var canGwpDecXMASCARE2 = false;
        var hasGwpDecXMASCARE3 = false;
        var canGwpDecXMASCARE3 = false;

        // promocode CT2020 | Duration 26 Oct - 31 Nov | By inscoder
        var hasGwpOctNovCT20201 = false;
        var canGwpOctNovCT20201 = false;
        var hasGwpOctNovCT20202 = false;
        var canGwpOctNovCT20202 = false;
        var hasGwpOctNovCT20203 = false;
        var canGwpOctNovCT20203 = false;

        for (let i = 0; i <= response.items.length - 1; i++) {
            if (response.items[i].quantity > 3) {
                await updateItemById(response.items[i].key, 3, {});
            }

            if (window.constants.giftMessage == response.items[i].id) {
                hasGift = true;
                giftKey = response.items[i].key;
            }

            if (window.constants.giftMessageMaison == response.items[i].id) {
                hasMaisonGift = true;
                giftKey = response.items[i].key;
            }

            if (response.items[i].vendor === "Maison Christian Dior") {
                maison = true;
            }

            if (response.items[i].id === 34919627718808 && !mcd2020inCart) {
                mcd2020inCart = response.items[i].key;
            }

            // Aug 1 GWP
            if (response.items[i].product_type === "Makeup" && !window.constants.gwpArray.includes(response.items[i].id)) {
                makeupCount = makeupCount + response.items[i].quantity;
            }

            if (response.items[i].id === window.constants.browCard) {
                hasBrowCard = response.items[i].key;
            }

            // Limit one per GWP,
            if (window.constants.gwpArray.includes(response.items[i].id)) {
                for (let j = 0; j <= window.constants.gwpArray.length - 1; j++) {
                    if (response.items[i].id === window.constants.gwpArray[j].id && response.items[i].quantity > getQtyTotal(response.items[i])) {
                        await updateItemById(response.items[i].key, 1, {});
                    }
                }
            }

            // // BeautyEx code
            // if (window.constants.collectionIds.includes(response.items[i].id)) {
            //     canBeauty = true;
            //     beautyProducts.push(response.items[i].key);
            //     // beautyCount = beautyCount + response.items[i].quantity;
            // }

            // // if (window.constants.collectionEligibleIds.includes(response.items[i].id)) {
            // //     beautyCount = beautyCount + response.items[i].quantity;
            // //     canBeauty = true;
            // // } else {
            // //     canBeauty = false;
            // // }

            // if (response.items[i].id === 35602125815960 && !hasBeauty) {
            //     hasBeauty = true;
            // }


            // Removing the GWPs
            // if (response.items[i].vendor === "Maison Christian Dior" && response.items[i].product_type === "Gift Set" && !canJulyGwp) {
            //     canJulyGwp = true;
            // }

            if (response.items[i].vendor === "Maison Christian Dior" && !hasMaisonProducts) {
                hasMaisonProducts = true;
            }

            if (response.items[i].id === window.constants.noMcdCard && !hasMaisonCard) {
                hasMaisonCard = response.items[i].key;
            }

            // Add GWP Check
            if (gwpTotal >= window.constants.gwp[1].min && !doesCartHaveGwp('C400070653') && !canGwp1) {
                canGwp1 = true;
            }

            removeGwp1 = false;
            if (gwpTotal < window.constants.gwp[1].min && doesCartHaveGwp('C400070653')) {
                removeGwp1 = true;
            }


            // OCT GWP 1
            // GWP F648119000
            // If cart contains  SCSET01 = 35833317949592 OR SCSET02 = 35833394135192
            if ((response.items[i].id === 35833317949592 || response.items[i].id === 35833394135192) && !doesCartHaveGwp('F648119000') && !canGwpOct1) {
                canGwpOct1 = true;
                console.log("canGwpOct1",canGwpOct1);
            }

            // OCT GWP 2 - Coming for Christmas

            // OCT GWP 3
            // GWP C199600427
            // If cart contains SCSET03 = 35833530646680
            if ((response.items[i].id === 35833530646680) && !doesCartHaveGwp('C199600427') && !canGwpOct3) {
                canGwpOct3 = true;
                console.log("canGwpOct3",canGwpOct3);
            }            




            // if (makeupCount >= 2 && !doesCartHaveGwp('C400070462') && !canGwp2) {
            //     canGwp2 = true;
            // }

            // if (gwpTotal >= window.constants.gwp[2].min && window.hasCodeStack(window.constants.gwp[2].code)) {
            //     canGwp3 = true;
            // }

            // if (!canGwp4 && window.hasCodeStack(window.constants.gwp[3].code) && (response.items[i].product_id === 5739070095512 || response.items[i].product_id === 4933362221189)) { // add has eligible products
            //     canGwp4 = true;
            // }

            // Upon purchase of any Xmas Staycation Items | 26 Oct – 30 Nov
            if (eligibleGwpOctNovXmasStaycation.includes(response.items[i].sku) && !canGwpOctNovXmasStaycation) {
                canGwpOctNovXmasStaycation = true;
            }
            // JAD EDP SPL MINIA FB 5ML INT18 | Any purchase of any 2 J'adore products | Duration 26 Oct - 31 Dec | By inscoder
            if (response.items[i].vendor === "J'adore" && !window.constants.gwpArray.includes(response.items[i].id)) {
                jadoreCount = jadoreCount + response.items[i].quantity;
            }
            if (jadoreCount >= 2 && !canGwpNovDec1) {
                canGwpNovDec1 = true;
            }

            // // HK ePop up Xmas Invitation Card | Duration 1 Nov - 15 Dec | By inscoder
            // if (eligibleSKUInvitCard.includes(response.items[i].sku)){
            //     canGwpNovDecInvitCard = true;
            // }


            if (window.hasDmCodeStack()) {
                canGwp5 = true;
            }

            if (!window.hasCodeStack("CTCOSMO")) {
                canGwp6 = false;
                canGwp7 = false;
                canGwp8 = false;
            }

            if (!window.hasCodeStack("BEAUTYEX")) {
                canBeauty = false;
            }




            if (!window.hasCodeStack("ROSE")) {
                canGwpOctROSE1 = false;
                canGwpOctROSE2 = false;
                canGwpOctROSE3 = false;
            } else {
                canGwpOctROSE1 = true;
                canGwpOctROSE2 = true;
                canGwpOctROSE3 = true;
            }

            if (!window.hasCodeStack("PRESTIGE")) {
                canGwpOctPRESTIGE1 = false;
                canGwpOctPRESTIGE2 = false;
                canGwpOctPRESTIGE3 = false;
            }  else {
                canGwpOctPRESTIGE1 = true;
                canGwpOctPRESTIGE2 = true;
                canGwpOctPRESTIGE3 = true;
            }             

            if (!window.hasCodeStack("LOVEROSE")) {
                canGwpOctLOVEROSE1 = false;
                canGwpOctLOVEROSE2 = false;
                canGwpOctLOVEROSE3 = false;
            } else {
                canGwpOctLOVEROSE1 = true;
                canGwpOctLOVEROSE2 = true;
                canGwpOctLOVEROSE3 = true;
            }       
            

            if (!window.hasCodeStack("XMAS800")) {
                canGwpOctXMAS800 = false;
            } else {
                if (gwpTotal >= window.constants.gwp[12].min && window.hasCodeStack(window.constants.gwp[12].code)) {
                    canGwpOctXMAS800 = true;
                }  
            }

          

            if (!window.hasCodeStack("GOLDENIGHTS")) {
                canGwpOctGOLDENIGHTS = false;
            } else {
                canGwpOctGOLDENIGHTS = true;
            }

            // promocode BOCOM | Duration 1 Sep - 31 Dec
            if (!window.hasCodeStack("BOCOM")) {
                canBOCOM = false;
            } else {
                canBOCOM = true;
            }

            // promocode MCDHOME | Duration 16 - 31 Dec | By inscoder
            if (!window.hasCodeStack("MCDHOME")) {
                canGwpDecMCDHOME1 = false;
                canGwpDecMCDHOME2 = false;
                canGwpDecMCDHOME3 = false;
            } else {
                canGwpDecMCDHOME1 = true;
                canGwpDecMCDHOME2 = true;
                canGwpDecMCDHOME3 = true;
            }

            // promocode HOLIDAY | Duration 1 - 31 Dec | By inscoder
            if (!window.hasCodeStack("HOLIDAY")) {
                canGwpDecHOLIDAY1 = false;
                canGwpDecHOLIDAY2 = false;
                canGwpDecHOLIDAY3 = false;
            } else {
                canGwpDecHOLIDAY1 = true;
                canGwpDecHOLIDAY2 = true;
                canGwpDecHOLIDAY3 = true;
            }

            // promocode ILOVEXMAS | Duration 11 Nov - 24 Dec | By inscoder
            if (!window.hasCodeStack("ILOVEXMAS")) {
                canGwpNovDecILOVEXMAS1 = false;
                canGwpNovDecILOVEXMAS2 = false;
                canGwpNovDecILOVEXMAS3 = false;
            } else {
                canGwpNovDecILOVEXMAS1 = true;
                canGwpNovDecILOVEXMAS2 = true;
                canGwpNovDecILOVEXMAS3 = true;
            }

            // promocode LOVEROUGE | Duration 15 Oct - 31 Nov | By inscoder
            if (!window.hasCodeStack("LOVEROUGE")) {
                canGwpOctNovLOVEROUGE1 = false;
                canGwpOctNovLOVEROUGE2 = false;
                canGwpOctNovLOVEROUGE3 = false;
            } else {
                canGwpOctNovLOVEROUGE1 = true;
                canGwpOctNovLOVEROUGE2 = true;
                canGwpOctNovLOVEROUGE3 = true;
            }

            // promocode XMASCARE | Duration 1 Dec - 24 Dec | By inscoder
            if (!window.hasCodeStack("XMASCARE")) {
                canGwpDecXMASCARE1 = false;
                canGwpDecXMASCARE2 = false;
                canGwpDecXMASCARE3 = false;
            } else {
                canGwpDecXMASCARE1 = true;
                canGwpDecXMASCARE2 = true;
                canGwpDecXMASCARE3 = true;
            }

            // promocode CT2020 | Duration 26 Oct - 31 Nov | By inscoder
            if (!window.hasCodeStack("CT2020")) {
                canGwpOctNovCT20201 = false;
                canGwpOctNovCT20202 = false;
                canGwpOctNovCT20203 = false;
            } else {
                canGwpOctNovCT20201 = true;
                canGwpOctNovCT20202 = true;
                canGwpOctNovCT20203 = true;
            }


            hasGwp1 = doesCartHaveGwp('C400070653');
            hasGwp2 = doesCartHaveGwp('C400070462');
            hasGwp3 = doesCartHaveGwp('C400070638');
            hasGwp4 = doesCartHaveGwp('C400000742C013673010');
            hasGwp5 = doesCartHaveGwp('C400000580');
            hasGwp6 = doesCartHaveGwp('C199600405');
            hasGwp7 = doesCartHaveGwp('C199600404');
            hasGwp8 = doesCartHaveGwp('C800200092');
            hasGwpOct1 = doesCartHaveGwp('F648119000');
            hasGwpOct2 = doesCartHaveGwp('C104500010');
            hasGwpOct3 = doesCartHaveGwp('C199600427');
            hasGwpOctXMAS800 = doesCartHaveGwp('HKC102673999A');
            hasGwpOctGOLDENIGHTS = doesCartHaveGwp('HKC800200091A');
            hasGwpOctROSE1 = doesCartHaveGwp('C400000758');
            hasGwpOctROSE2 = doesCartHaveGwp('F167057000');
            hasGwpOctROSE3 = doesCartHaveGwp('F185011000');
            hasGwpOctPRESTIGE1 = doesCartHaveGwp('C400000758');
            hasGwpOctPRESTIGE2 = doesCartHaveGwp('F167038000');
            hasGwpOctPRESTIGE3 = doesCartHaveGwp('F185011000');  
            hasGwpOctLOVEROSE1 = doesCartHaveGwp('C400000758');
            hasGwpOctLOVEROSE2 = doesCartHaveGwp('C199600250');
            hasGwpOctLOVEROSE3 = doesCartHaveGwp('F185011000');

            hasBOCOM = doesCartHaveGwp('HKC800200088A'); // promocode BOCOM | Duration 1 Sep - 31 Dec
            
            hasGwpOctNovXmasStaycation = doesCartHaveGwp('C104500010'); // Duration 26 Oct – 30 Nov | By inscoder
            hasGwpNovDec1A = doesCartHaveGwp('C199600072'); // Duration 26 Oct - 31 Dec | By inscoder
            hasGwpNovDec1B = doesCartHaveGwp('C400000439'); // Duration 26 Oct - 31 Dec | By inscoder
            // hasGwpNovDecInvitCard = doesCartHaveGwp('HKXMAS202011'); // Duration 1 Nov - 31 Dec | By inscoder

            // promocode MCDHOME | Duration 16 - 31 Dec | By inscoder
            hasGwpDecMCDHOME1 = doesCartHaveGwp('C199600291');
            hasGwpDecMCDHOME2 = doesCartHaveGwp('C199600195');
            hasGwpDecMCDHOME3 = doesCartHaveGwp('C199600191');

            // promocode HOLIDAY | Duration 1 - 31 Dec | By inscoder
            hasGwpDecHOLIDAY1 = doesCartHaveGwp('C800300111');
            hasGwpDecHOLIDAY2 = doesCartHaveGwp('C400000829');

            // promocode ILOVEXMAS | Duration 11 Nov - 24 Dec | By inscoder
            hasGwpNovDecILOVEXMAS1 = doesCartHaveGwp('C800200090');
            hasGwpNovDecILOVEXMAS2 = doesCartHaveGwp('C105600001');
            hasGwpNovDecILOVEXMAS3 = doesCartHaveGwp('C104500020');

            // promocode LOVEROUGE | Duration 15 Oct - 31 Nov | By inscoder
            hasGwpOctNovLOVEROUGE1 = doesCartHaveGwp('C800200091');
            hasGwpOctNovLOVEROUGE2 = doesCartHaveGwp('C199600436');
            hasGwpOctNovLOVEROUGE3 = doesCartHaveGwp('C104500020');

            // promocode XMASCARE | Duration 1 Dec - 24 Dec | By inscoder
            hasGwpDecXMASCARE1 = doesCartHaveGwp('C800200089');
            hasGwpDecXMASCARE2 = doesCartHaveGwp('F167058000');
            hasGwpDecXMASCARE3 = doesCartHaveGwp('F185011000');

            // promocode CT2020 | Duration 26 Oct - 31 Nov | By inscoder
            hasGwpOctNovCT20201 = doesCartHaveGwp('C800200089');
            hasGwpOctNovCT20202 = doesCartHaveGwp('F185100000');
            hasGwpOctNovCT20203 = doesCartHaveGwp('F185011000');

        }

        if (response.items.length > 0) {

            console.log("canGwp1", canGwp1, "hasGwp1", hasGwp1, "canGwp2", canGwp2, "hasGwp2", hasGwp2,
                        "canGwp3", canGwp3, "hasGwp3", hasGwp3, "canGwp4", canGwp4, "hasGwp4", hasGwp4, 
                        "hasGwp5", hasGwp5 , "hasGwp6", hasGwp6, "hasGwp7", hasGwp7, "hasGwp8", hasGwp8,
                        "hasGwpOct1", hasGwpOct1 , "hasGwpOct2", hasGwpOct2, "hasGwpOct3", hasGwpOct3,"hasGwpOctXMAS800", hasGwpOctXMAS800,"canGwpOctXMAS800", canGwpOctXMAS800,"hasGwpOctGOLDENIGHTS", hasGwpOctGOLDENIGHTS,"canGwpOctGOLDENIGHTS", canGwpOctGOLDENIGHTS,"hasGwpOctROSE1", hasGwpOctROSE1,"canGwpOctROSE1", canGwpOctROSE1,"hasGwpOctROSE2", hasGwpOctROSE2,"canGwpOctROSE2", canGwpOctROSE2,"hasGwpOctROSE3", hasGwpOctROSE3,"canGwpOctROSE3", canGwpOctROSE3,"hasGwpOctPRESTIGE1", hasGwpOctPRESTIGE1,"canGwpOctPRESTIGE1", canGwpOctPRESTIGE1,"hasGwpOctPRESTIGE2", hasGwpOctPRESTIGE2,"canGwpOctPRESTIGE2", canGwpOctPRESTIGE2,"hasGwpOctPRESTIGE3", hasGwpOctPRESTIGE3,"canGwpOctPRESTIGE3", canGwpOctPRESTIGE3,"hasGwpOctLOVEROSE1", hasGwpOctLOVEROSE1,"canGwpOctLOVEROSE1", canGwpOctLOVEROSE1,"hasGwpOctLOVEROSE2", hasGwpOctLOVEROSE2, "canGwpOctLOVEROSE2", canGwpOctLOVEROSE2,"hasGwpOctLOVEROSE3", hasGwpOctLOVEROSE3,"canGwpOctLOVEROSE3",canGwpOctLOVEROSE3);



            // Upon puchase Prestige Virtual Set (SCSET01 & SCSET02)            
            if (canGwpOct1 && !hasGwpOct1) {
                await _addItem(window.constants.gwp[0].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING gcanGwpOct1 F648119000", response);
                });
            }


            if (canGwpOct3 && !hasGwpOct3) {
                await _addItem(window.constants.gwp[8].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING gcanGwpOct3 C199600427", response);
                });
            }            


            if (canGwp1 && !hasGwp1) {
                await _addItem(window.constants.gwp[1].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING gwp1 C400070653", response);
                });
            }

            // Taken over by October1
            // if (canGwp2 && !hasGwp2) {
            //     await _addItem(window.constants.gwp[0].id.toString(), 1, {}).then(async function (response) {
            //         console.log("ADDING gwp2 C400070462", response);
            //     });
            // }

            if (canGwp3 && !hasGwp3 ) {
                await _addItem(window.constants.gwp[2].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING gwp3 C400070638", response);
                });
            }

            if (canGwp4 && !hasGwp4) {
                await _addItem(window.constants.gwp[3].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING gwp4 C400000742C013673010", response);
                });
            }


            if (canGwp5 && !hasGwp5) {
                await _addItem(window.constants.gwp[4].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING gwp5 C400000580", response);
                });
            }




            // START OCTOBER WORK
            // ADDING GIFTS BASED ON CODES
             
            // XMAS800
            if (canGwpOctXMAS800 && !hasGwpOctXMAS800) {
                await _addItem(window.constants.gwp[12].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING XMAS800 HKC102673999A", response);
                });
            }

            // GOLDENIGHTS
            if (canGwpOctGOLDENIGHTS && !hasGwpOctGOLDENIGHTS) {
                await _addItem(window.constants.gwp[13].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING GOLDENIGHTS HKC800200091A", response);
                });
            }            


            // ROSE a
            if (canGwpOctROSE1 && !hasGwpOctROSE1 && !hasGwpOctPRESTIGE1 && !hasGwpOctLOVEROSE1) {
                await _addItem(window.constants.gwp[9].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING ROSE C400000758", response);
                });
            }
            
            // ROSE b
            if (canGwpOctROSE2 && !hasGwpOctROSE2) {
                await _addItem(window.constants.gwp[10].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING ROSE F167057000", response);
                });
            }
            
            // ROSE c
            if (canGwpOctROSE3 && !hasGwpOctROSE3 && !hasGwpOctPRESTIGE3 && !hasGwpOctLOVEROSE3 && !hasGwpOctNovCT20203 && !hasGwpDecXMASCARE3) {
                await _addItem(window.constants.gwp[11].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING ROSE F185011000", response);
                });
            }    


            // PRESTIGE a
            if (canGwpOctPRESTIGE1 && !hasGwpOctROSE1 && !hasGwpOctPRESTIGE1 && !hasGwpOctLOVEROSE1) {
                await _addItem(window.constants.gwp[14].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING PRESTIGE C400000758", response);
                });
            }
            
            // PRESTIGE b
            if (canGwpOctPRESTIGE2 && !hasGwpOctPRESTIGE2) {
                await _addItem(window.constants.gwp[15].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING PRESTIGE F167038000", response);
                });
            }
            
            // PRESTIGE c
            if (canGwpOctPRESTIGE3 && !hasGwpOctROSE3 && !hasGwpOctPRESTIGE3 && !hasGwpOctLOVEROSE3 && !hasGwpOctNovCT20203 && !hasGwpDecXMASCARE3) {
                await _addItem(window.constants.gwp[16].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING PRESTIGE F185011000", response);
                });
            }    


            // LOVEROSE a
            if (canGwpOctLOVEROSE1 && !hasGwpOctROSE1 && !hasGwpOctPRESTIGE1 && !hasGwpOctLOVEROSE1) {
                await _addItem(window.constants.gwp[17].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING LOVEROSE C400000758", response);
                });
            }
            
            // LOVEROSE b
            if (canGwpOctLOVEROSE2 && !hasGwpOctLOVEROSE2) {
                await _addItem(window.constants.gwp[18].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING LOVEROSE F167038000", response);
                });
            }
            
            // LOVEROSE c
            if (canGwpOctLOVEROSE3 && !hasGwpOctROSE3 && !hasGwpOctPRESTIGE3 && !hasGwpOctLOVEROSE3 && !hasGwpOctNovCT20203 && !hasGwpDecXMASCARE3) {
                await _addItem(window.constants.gwp[19].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING LOVEROSE F185011000", response);
                });
            }  

            // BOCOM | 1 Sep - 31 Dec
            if (canBOCOM && !hasBOCOM) {
                await _addItem(window.constants.gwp[20].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING BOCOM HKC800200088A", response);
                });
            }


            // END OCTOBER WORK


            // CTCOSMO a
            if (canGwp6 && !hasGwp6) {
                await _addItem(window.constants.gwp[5].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING gwp6 C199600405", response);
                });
            }
            
            // CTCOSMO b
            if (canGwp7 && !hasGwp7) {
                await _addItem(window.constants.gwp[6].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING gwp7 C199600404", response);
                });
            }
            
            // CTCOSMO c
            if (canGwp8 && !hasGwp8) {
                await _addItem(window.constants.gwp[7].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING gwp8 C800200092", response);
                });
            }       
            
            // BeautyEx
            if (canBeauty && !hasBeauty) {
                await _addItem("35602125815960", 1, {}).then(async function (response) {
                    console.log("ADDING BeutyEx 35602125815960", response);
                });
            }

            // Inscoder adding items
            // Add C104500010 Upon purchase of any Xmas Staycation Items | 26 Oct – 30 Nov 
            if (canGwpOctNovXmasStaycation && !hasGwpOctNovXmasStaycation) {
                await _addItem(window.constants.gwp[21].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING 恆久貼肌柔霧粉底液 1N 5ml 36480776601752", response);
                });
            }
            // Remove
            if (!canGwpOctNovXmasStaycation && hasGwpOctNovXmasStaycation) {
                await updateItemById(doesCartHaveGwp('C104500010'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    console.log("REMOVE 恆久貼肌柔霧粉底液 1N 5ml C104500010", response);
                });
            }

            // add SKU C199600072 Any purchase of any 2 J'adore products | 26 Oct - 31 Dec
            if (canGwpNovDec1 && !hasGwpNovDec1A) {
                await _addItem(window.constants.gwp[22].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING J'adore 香薰 5ml 33886040686725", response);
                });
            }
            if (canGwpNovDec1 && !hasGwpNovDec1B) {
                await _addItem(window.constants.gwp[23].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING J'adore 精美化妝袋 33801133654149", response);
                });
            }
            // Remove
            if (!canGwpNovDec1 && hasGwpNovDec1A) {
                await updateItemById(doesCartHaveGwp('C199600072'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    console.log("REMOVE J'adore 香薰 5ml C199600072", response);
                });
            }
            if (!canGwpNovDec1 && hasGwpNovDec1B) {
                await updateItemById(doesCartHaveGwp('C400000439'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    console.log("REMOVE J'adore 精美化妝袋 C400000439", response);
                });
            }

            // // HK ePop up Xmas Invitation Card | Duration 1 Nov - 15 Dec | By inscoder
            // // Add HKXMAS202011 Upon purchase fragrance 100mL (MISS DIOR / J'ADORE / SAUVAGE)
            // if (canGwpNovDecInvitCard && !hasGwpNovDecInvitCard) {
            //     await _addItem(window.constants.gwp[23].id.toString(), 1, {}).then(async function (response) {
            //         console.log("ADDING X'mas Invitation Card 36961858453656", response);
            //     });
            // }
            // // Remove
            // if (!canGwpNovDecInvitCard && hasGwpNovDecInvitCard) {
            //     await updateItemById(doesCartHaveGwp('HKXMAS202011'), 0, {}).then(async function (response) {
            //         window.updateCartCache(response);
            //         console.log("REMOVE X'mas Invitation Card HKXMAS202011", response);
            //     });
            // }
            // promocode MCDHOME | Duration 16 - 31 Dec | By inscoder
            // MCDHOME a
            if (canGwpDecMCDHOME1 && !hasGwpDecMCDHOME1) {
                await _addItem(window.constants.gwp[24].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING MCDHOME C199600291", response);
                });
            }
            
            // MCDHOME b
            if (canGwpDecMCDHOME2 && !hasGwpDecMCDHOME2) {
                await _addItem(window.constants.gwp[25].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING MCDHOME C199600195", response);
                });
            }
            
            // MCDHOME c
            if (canGwpDecMCDHOME3 && !hasGwpDecMCDHOME3) {
                await _addItem(window.constants.gwp[26].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING MCDHOME C199600191", response);
                });
            }    

            // promocode HOLIDAY | Duration 1 - 31 Dec | By inscoder
            // HOLIDAY a
            if (canGwpDecMCDHOME1 && !hasGwpDecMCDHOME1) {
                await _addItem(window.constants.gwp[27].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING HOLIDAY C800300111", response);
                });
            }
            
            // HOLIDAY b
            if (canGwpDecMCDHOME2 && !hasGwpDecMCDHOME2) {
                await _addItem(window.constants.gwp[28].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING HOLIDAY C400000829", response);
                });
            }

            // promocode ILOVEXMAS | Duration 11 Nov - 24 Dec | By inscoder
            // ILOVEXMAS a
            if (canGwpNovDecILOVEXMAS1 && !hasGwpNovDecILOVEXMAS1) {
                await _addItem(window.constants.gwp[29].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING ILOVEXMAS C800200090", response);
                });
            }
            
            // ILOVEXMAS b
            if (canGwpNovDecILOVEXMAS2 && !hasGwpNovDecILOVEXMAS2) {
                await _addItem(window.constants.gwp[30].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING ILOVEXMAS C105600001", response);
                });
            }
            
            // ILOVEXMAS c
            if (canGwpNovDecILOVEXMAS3 && !hasGwpNovDecILOVEXMAS3 && !hasGwpOctNovLOVEROUGE3) {
                await _addItem(window.constants.gwp[31].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING ILOVEXMAS C104500020", response);
                });
            }    

            // promocode LOVEROUGE | Duration 15 Oct - 31 Nov | By inscoder
            // LOVEROUGE a
            if (canGwpOctNovLOVEROUGE1 && !hasGwpOctNovLOVEROUGE1) {
                await _addItem(window.constants.gwp[32].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING LOVEROUGE C800200091", response);
                });
            }
            
            // LOVEROUGE b
            if (canGwpOctNovLOVEROUGE2 && !hasGwpOctNovLOVEROUGE2) {
                await _addItem(window.constants.gwp[33].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING LOVEROUGE C199600436", response);
                });
            }
            
            // LOVEROUGE c
            if (canGwpOctNovLOVEROUGE3 && !hasGwpOctNovLOVEROUGE3 && !hasGwpNovDecILOVEXMAS3) {
                await _addItem(window.constants.gwp[34].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING LOVEROUGE C104500020", response);
                });
            }    

            // promocode XMASCARE | Duration 1 Dec - 24 Dec | By inscoder
            // XMASCARE a
            if (canGwpDecXMASCARE1 && !hasGwpDecXMASCARE1 && !hasGwpOctNovCT20201) {
                await _addItem(window.constants.gwp[35].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING XMASCARE C800200089", response);
                });
            }
            
            // XMASCARE b
            if (canGwpDecXMASCARE2 && !hasGwpDecXMASCARE2) {
                await _addItem(window.constants.gwp[36].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING XMASCARE F167058000", response);
                });
            }
            
            // XMASCARE c
            if (canGwpDecXMASCARE3 && !hasGwpDecXMASCARE3 && !hasGwpOctNovCT20203 && !hasGwpOctROSE3 && !hasGwpOctPRESTIGE3 && !hasGwpOctLOVEROSE3) {
                await _addItem(window.constants.gwp[37].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING XMASCARE F185011000", response);
                });
            }

            // promocode CT2020 | Duration 26 Oct - 31 Nov | By inscoder
            // CT2020 a
            if (canGwpOctNovCT20201 && !hasGwpOctNovCT20201 && !hasGwpDecXMASCARE1) {
                await _addItem(window.constants.gwp[38].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING CT2020 C800200089", response);
                });
            }
            
            // CT2020 b
            if (canGwpOctNovCT20202 && !hasGwpOctNovCT20202) {
                await _addItem(window.constants.gwp[39].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING CT2020 F185100000", response);
                });
            }
            
            // CT2020 c
            if (canGwpOctNovCT20203 && !hasGwpOctNovCT20203 && !hasGwpDecXMASCARE3 && !hasGwpOctROSE3 && !hasGwpOctPRESTIGE3 && !hasGwpOctLOVEROSE3) {
                await _addItem(window.constants.gwp[40].id.toString(), 1, {}).then(async function (response) {
                    console.log("ADDING CT2020 F185011000", response);
                });
            }

            // End Inscoder adding/remove items

            // // Remove GWP check
            // if (!canGwp1 && hasGwp1) {
            if (removeGwp1 && hasGwp1) {                
                await updateItemById(doesCartHaveGwp('C400070653'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    console.log("REMOVE gwp1 C400070653", response);
                });
            }


            if (!canGwp2 && hasGwp2) {
                await updateItemById(doesCartHaveGwp('C400070462'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    console.log("REMOVE gwp2 C400070462", response);
                });
            }

            if (!canGwp3) {
                window.removeCodeStack(window.constants.gwp[2].code);
            }

            if ( (!canGwp3 && hasGwp3) ) {
                
                await updateItemById(doesCartHaveGwp('C400070638'), 0, {}).then(async function (response) {
                    window.removeCodeStack(window.constants.gwp[2].code);
                    window.updateCartCache(response);
                    console.log("REMOVE gwp3 C400070638", response);
                    
                });
            }





            if (!canGwp4) {
                window.removeCodeStack(window.constants.gwp[3].code);
            }

            if (!canGwp4 && hasGwp4) {
                await updateItemById(doesCartHaveGwp('C400000742C013673010'), 0, {}).then(async function (response) {
                    window.removeCodeStack(window.constants.gwp[3].code);
                    window.updateCartCache(response);
                    console.log("REMOVE gwp4 C400000742C013673010", response);
                    
                });
            }

            if (!canGwp5) {
                window.removeDmCodeStack();
            }

            if (!canGwp5 && hasGwp5) {
                await updateItemById(doesCartHaveGwp('C400000580'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE gwp5 C400000580", response);
                });
            }











            // START OCTOBER WORK
            // REMOVING GIFTS BASED ON CODES


            if ( (!canGwpOct1 && hasGwpOct1) ) {
                
                await updateItemById(doesCartHaveGwp('F648119000'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    console.log("REMOVE gwpOCT3 F648119000", response);
                    
                });
            }

            if ( (!canGwpOct3 && hasGwpOct3) ) {
                
                await updateItemById(doesCartHaveGwp('C199600427'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    console.log("REMOVE gwpOCT3 C199600427", response);
                    
                });
            }
            
            

             
            // XMAS800
            if (!canGwpOctXMAS800 && hasGwpOctXMAS800) {
                await updateItemById(doesCartHaveGwp('HKC102673999A'), 0, {}).then(async function (response) {
                        window.updateCartCache(response);
                        window.removeDmCodeStack();

                    console.log("REMOVE XMAS800 HKC102673999A", response);
                });
            }

            // GOLDENIGHTS
            if (!canGwpOctGOLDENIGHTS && hasGwpOctGOLDENIGHTS) {
                await updateItemById(doesCartHaveGwp('HKC800200091A'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE GOLDENIGHTS HKC800200091A", response);
                });
            }            

            // ROSE a

            
            // if (!canGwpOctROSE1 && hasGwpOctROSE1) {
            if ((!canGwpOctROSE1 && !canGwpOctPRESTIGE1 && !canGwpOctLOVEROSE1) && hasGwpOctROSE1) {                
                await updateItemById(doesCartHaveGwp('C400000758'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE ROSE, PRESTIGE, LOVEROSE C400000758", response);
                });
            }
            
            // ROSE b
            if (!canGwpOctROSE2 && hasGwpOctROSE2) {
                await updateItemById(doesCartHaveGwp('F167057000'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE ROSE F167057000", response);
                });
            }
            
            // ROSE c
            if ((!canGwpOctLOVEROSE3 && !canGwpOctPRESTIGE3 && !canGwpOctROSE3 && !canGwpDecXMASCARE3 && !canGwpOctNovCT20203) && hasGwpOctROSE3) {
                await updateItemById(doesCartHaveGwp('F185011000'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE ROSE, PRESTIGE, LOVEROSE, XMASCARE, CT2020 F185011000", response);
                });
            }    

            // BOCOM | 1 Sep - 31 Dec
            if (!canBOCOM && hasBOCOM) {
                await updateItemById(doesCartHaveGwp('HKC800200088A'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    // window.removeCodeStack(window.constants.gwp[5].code);
                    console.log("REMOVE BOCOM C199600405", response);
                });
            }

            // promocode MCDHOME | Duration 16 - 31 Dec | By inscoder
            // MCDHOME a
            if (!canGwpDecMCDHOME1 && hasGwpDecMCDHOME1) {                
                await updateItemById(doesCartHaveGwp('C199600291'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE MCDHOME C199600291", response);
                });
            }
            
            // MCDHOME b
            if (!canGwpDecMCDHOME2 && hasGwpDecMCDHOME2) {
                await updateItemById(doesCartHaveGwp('C199600195'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE MCDHOME C199600195", response);
                });
            }
            
            // MCDHOME c
            if (!canGwpDecMCDHOME3 && hasGwpDecMCDHOME3) {
                await updateItemById(doesCartHaveGwp('C199600191'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE MCDHOME C199600191", response);
                });
            }

            // promocode HOLIDAY | Duration 1 - 31 Dec | By inscoder
            // HOLIDAY a
            if (!canGwpDecHOLIDAY1 && hasGwpDecHOLIDAY1) {                
                await updateItemById(doesCartHaveGwp('C800300111'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE HOLIDAY C800300111", response);
                });
            }
            // HOLIDAY b
            if (!canGwpDecHOLIDAY2 && hasGwpDecHOLIDAY2) {
                await updateItemById(doesCartHaveGwp('C400000829'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE HOLIDAY C400000829", response);
                });
            }

            // promocode ILOVEXMAS | Duration 11 Nov - 24 Dec | By inscoder
            // ILOVEXMAS a
            if (!canGwpNovDecILOVEXMAS1 && hasGwpNovDecILOVEXMAS1) {                
                await updateItemById(doesCartHaveGwp('C800200090'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE ILOVEXMAS C800200090", response);
                });
            }
            // ILOVEXMAS b
            if (!canGwpNovDecILOVEXMAS2 && hasGwpNovDecILOVEXMAS2) {
                await updateItemById(doesCartHaveGwp('C105600001'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE ILOVEXMAS C105600001", response);
                });
            }
            // ILOVEXMAS c
            if ((!canGwpNovDecILOVEXMAS3 && !canGwpOctNovLOVEROUGE3) && hasGwpNovDecILOVEXMAS3) {
                await updateItemById(doesCartHaveGwp('C104500020'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE ILOVEXMAS, LOVEROUGE C104500020", response);
                });
            }    
            
            // promocode LOVEROUGE | Duration 15 Oct - 31 Nov | By inscoder
            // LOVEROUGE a
            if (!canGwpOctNovLOVEROUGE1 && hasGwpOctNovLOVEROUGE1) {                
                await updateItemById(doesCartHaveGwp('C800200091'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE LOVEROUGE C800200091", response);
                });
            }
            // LOVEROUGE b
            if (!canGwpOctNovLOVEROUGE2 && hasGwpOctNovLOVEROUGE2) {
                await updateItemById(doesCartHaveGwp('C199600436'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE LOVEROUGE C199600436", response);
                });
            }
            // LOVEROUGE c (same as "ILOVEXMAS c" so commented)
            // if ((!canGwpOctNovLOVEROUGE3 && !canGwpNovDecILOVEXMAS3) && hasGwpOctNovLOVEROUGE3) {
            //     await updateItemById(doesCartHaveGwp('C104500020'), 0, {}).then(async function (response) {
            //         window.updateCartCache(response);
            //         window.removeDmCodeStack();
            //         console.log("REMOVE ILOVEXMAS, LOVEROUGE C104500020", response);
            //     });
            // }

            // promocode XMASCARE | Duration 1 Dec - 24 Dec | By inscoder
            // XMASCARE a
            if ((!canGwpDecXMASCARE1 && !canGwpOctNovCT20201) && hasGwpDecXMASCARE1) {                
                await updateItemById(doesCartHaveGwp('C800200089'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE XMASCARE, CT2020 C800200089", response);
                });
            }
            // XMASCARE b
            if (!canGwpDecXMASCARE2 && hasGwpDecXMASCARE2) {
                await updateItemById(doesCartHaveGwp('F167058000'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE XMASCARE F167058000", response);
                });
            }
            // // XMASCARE c
            // if ((!canGwpDecXMASCARE3 && !canGwpOctNovCT20203) && hasGwpDecXMASCARE3) {                
            //     await updateItemById(doesCartHaveGwp('F185011000'), 0, {}).then(async function (response) {
            //         window.updateCartCache(response);
            //         window.removeDmCodeStack();
            //         console.log("REMOVE XMASCARE, CT2020 F185011000", response);
            //     });
            // }

            // promocode CT2020 | Duration 26 Oct - 31 Nov | By inscoder
            // CT2020 a
            // if ((!canGwpOctNovCT20201 && !canGwpDecXMASCARE1) && hasGwpOctNovCT20201) {                
            //     await updateItemById(doesCartHaveGwp('C800200089'), 0, {}).then(async function (response) {
            //         window.updateCartCache(response);
            //         window.removeDmCodeStack();
            //         console.log("REMOVE CT2020 C800200089", response);
            //     });
            // }
            // CT2020 b
            if (!canGwpOctNovCT20202 && hasGwpOctNovCT20202) {
                await updateItemById(doesCartHaveGwp('F185100000'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE CT2020 F185100000", response);
                });
            }
            // // CT2020 c
            // if ((!canGwpOctNovCT20203 && !canGwpDecXMASCARE3) && hasGwpOctNovCT20203) {                
            //     await updateItemById(doesCartHaveGwp('F185011000'), 0, {}).then(async function (response) {
            //         window.updateCartCache(response);
            //         window.removeDmCodeStack();
            //         console.log("REMOVE XMASCARE, CT2020 F185011000", response);
            //     });
            // }

            // PRESTIGE a
            // if (!canGwpOctPRESTIGE1 && hasGwpOctPRESTIGE1) {
            // if ((!canGwpOctROSE1 && !canGwpOctPRESTIGE1 && !canGwpOctLOVEROSE1) && hasGwpOctROSE1) {                  
            //     await updateItemById(doesCartHaveGwp('C400000758'), 0, {}).then(async function (response) {
            //         window.updateCartCache(response);
            //         window.removeDmCodeStack();
            //         console.log("REMOVE PRESTIGE C400000758", response);
            //     });
            // }
            
            // PRESTIGE b
            if (!canGwpOctPRESTIGE2 && hasGwpOctPRESTIGE2) {
                await updateItemById(doesCartHaveGwp('F167038000'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE PRESTIGE F167038000", response);
                });
            }
            
            // // PRESTIGE c
            // if ((!canGwpOctLOVEROSE3 && !canGwpOctPRESTIGE3 && !canGwpOctROSE3) && hasGwpOctPRESTIGE3) {
            //     await updateItemById(doesCartHaveGwp('F185011000'), 0, {}).then(async function (response) {
            //         window.updateCartCache(response);
            //         window.removeDmCodeStack();
            //         console.log("REMOVE PRESTIGE F185011000", response);
            //     });
            // }    


            // PRESTIGE a
            // if (!canGwpOctLOVEROSE1 && hasGwpOctLOVEROSE1) {
            // if ((!canGwpOctROSE1 && !canGwpOctPRESTIGE1 && !canGwpOctLOVEROSE1) && hasGwpOctROSE1) {                  
            //     await updateItemById(doesCartHaveGwp('C400000758'), 0, {}).then(async function (response) {
            //         window.updateCartCache(response);
            //         window.removeDmCodeStack();
            //         console.log("REMOVE LOVEROSE C400000758", response);
            //     });
            // }
            
            // PRESTIGE b
            if (!canGwpOctLOVEROSE2 && hasGwpOctLOVEROSE2) {
                await updateItemById(doesCartHaveGwp('C199600250'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeDmCodeStack();
                    console.log("REMOVE LOVEROSE C199600250", response);
                });
            }
            
            // PRESTIGE c

            // if ((!canGwpOctLOVEROSE3 && !canGwpOctPRESTIGE3 && !canGwpOctROSE3) && hasGwpOctLOVEROSE3) {
            // // if (!canGwpOctLOVEROSE3 && hasGwpOctLOVEROSE3) {
            //     await updateItemById(doesCartHaveGwp('F185011000'), 0, {}).then(async function (response) {
            //         window.updateCartCache(response);
            //         window.removeDmCodeStack();
            //         console.log("REMOVE LOVEROSE F185011000", response);
            //     });
            // }  

            // END OCTOBER WORK






            // CTCOSMO a
            if (!canGwp6 && hasGwp6) {
                await updateItemById(doesCartHaveGwp('C199600405'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeCodeStack(window.constants.gwp[5].code);
                    console.log("REMOVE gwp6 C199600405", response);
                });
            }

            // CTCOSMO b
            if (!canGwp7 && hasGwp7) {
                await updateItemById(doesCartHaveGwp('C199600404'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeCodeStack(window.constants.gwp[6].code);
                    console.log("REMOVE gwp7 C199600404", response);
                });
            }   
            
            // CTCOSMO c
            if (!canGwp8 && hasGwp8) {
                await updateItemById(doesCartHaveGwp('C800200092'), 0, {}).then(async function (response) {
                    window.updateCartCache(response);
                    window.removeCodeStack(window.constants.gwp[7].code);
                    console.log("REMOVE gwp8 C800200092", response);
                });
            }               
            
            

            // BeautyEx Code

            console.log({'hasBeauty': hasBeauty, 'canBeauty': canBeauty, 'beautyCount': beautyCount});

            if (hasBeauty && !canBeauty) {
                    await updateItemById(window.constants.collectionIds.toString(), 0, {}).then(async function (response) {
                        console.log("REMOVED beautyProducts", response);
                        window.updateCartCache(response);
                        window.removeCodeStack("BEAUTYEX");
                    });
            }

            // NEW JULY GWP

            // Aug 1 GWP
            // console.log("brow", makeupCount, hasBrowCard);

            if (makeupCount >= 2 && !hasBrowCard) {
                await _addItem(window.constants.browCard.toString(), 1, {}).then(async function (response) {
                    // console.log("ADDING browCard", response);
                }); 
            }

            if (makeupCount < 2 && hasBrowCard !== false) {
                await updateItemById(hasBrowCard, 0, {}).then(async function (response) {
                    // console.log("REMOVED browCard", response);
                });
            }




            // Card for when no MCD products in cart
            // if (!hasMaisonProducts && !hasMaisonCard) {
            //     await _addItem(window.constants.noMcdCard.toString(), 1, {}).then(async function (response) {
            //         console.log("ADDING noMcdCard", response);
            //     }); 
            // }

            // if (hasMaisonProducts && hasMaisonCard) {
            //     await updateItemById(window.constants.noMcdCard.toString(), 0, {}).then(async function (response) {
            //         console.log("REMOVED noMcdCard", response);
            //     });
            // }

            if (mcd2020inCart && !hasMaisonProducts ) {
                await updateItemById(mcd2020inCart, 0, {}).then(async function (response) {
                    console.log("REMOVED mcd2020inCart", response);
                    window.removeCodeStack("MCD2020");
                });
            }
            

            var giftIdToAdd = (maison) ? window.constants.giftMessageMaison.toString() : window.constants.giftMessage.toString();

            // Woeful gift card message
            if (giftKey && hasMaisonGift && !maison && (!localStorage.getItem("gift_message_added"))) {
                await updateItemById(giftKey, 0, {}).then(async function (response) {
                    // console.log(`cart js deleted ${giftKey}`, response);
                    // localStorage.removeItem("gift_message");
                    localStorage.removeItem("gift_message_added");

                    await _addItem(giftIdToAdd, 1, { 'Gift Message': localStorage.getItem("gift_message") }).then(async function (response) {
                        localStorage.setItem("gift_message_added", "true");
                        // console.log(`${(maison ? 'maison' : 'normal')} add api ${giftIdToAdd}`, response);

                        // return await _getCart();
                    });  
                });
            }

            if (giftKey && hasGift && maison && (!localStorage.getItem("gift_message_added"))) {
                await updateItemById(giftKey, 0, {}).then(async function (response) {
                    // console.log(`cart js deleted ${giftKey}`, response);
                    // localStorage.removeItem("gift_message");
                    localStorage.removeItem("gift_message_added");

                    await _addItem(giftIdToAdd, 1, { 'Gift Message': localStorage.getItem("gift_message") }).then(async function (response) {
                        localStorage.setItem("gift_message_added", "true");
                        // console.log(`${(maison ? 'maison' : 'normal')} add api ${giftIdToAdd}`, response);

                        // return await _getCart();
                    });
                });
            }

            if (giftKey && (localStorage.getItem("gift_message")) && (hasGift || hasMaisonGift)) {
                await updateItemById(giftKey, 1, { 'Gift Message': localStorage.getItem("gift_message") }).then(function (response) {
                    // console.log(`cart js updated ${giftKey}`, response);
                    // localStorage.removeItem("gift_message");
                });
            }

            
            if (!giftKey && (localStorage.getItem("gift_message")) && (!localStorage.getItem("gift_message_added")) && (!hasGift || !hasMaisonGift)) {
                await _addItem(giftIdToAdd, 1, { 'Gift Message': localStorage.getItem("gift_message") }).then(async function (response) {
                    localStorage.setItem("gift_message_added","true");
                    // console.log(`${(maison ? 'maison' : 'normal')} add api ${giftIdToAdd}`, response);

                    // return await _getCart();
                });
            }

            
            if (giftKey && (!localStorage.getItem("gift_message")) && (hasGift || hasMaisonGift)) {
                await updateItemById(giftKey, 0, {}).then(async function (response) {
                    // console.log(`cart js deleted ${giftKey}`, response);
                    // localStorage.removeItem("gift_message");
                    localStorage.removeItem("gift_message_added");

                    return await _getCart();
                });
            }

            // End gift card message

            // SECOND OFFER CARD
            if (!doesCartHaveSample("HKF916831000CRMA") && window.theme.loggedin && !window.theme.existing && window.theme.orders_count === 0) {
                await _addItem(window.constants.samples[3].id.toString(), 1, {}).then(async function (response) {
                    // console.log("samples response5", response);
                    // return await _getCart();
                });
            }


            if (!doesCartHaveSample("C199600544")) {
                await _addItem(window.constants.samples[0].id.toString(), 1, {}).then(async function (response) {
                    // console.log("addItem C199600544", response);
                    // return await _getCart();
                });
            }            

            if (!doesCartHaveSample("C108370010")) {
                await _addItem(window.constants.samples[1].id.toString(), 1, {}).then(async function (response) {
                    // console.log("addItem C199600392", response);
                    // return await _getCart();

                });
            }

            // 2 Sample C199600417 | J'adore Eau de Parfum & Body Milk Sampling Kit | Duration 26 Oct- 31 Dec | By inscoder
            if (!doesCartHaveSample("C199600417")) {
                await _addItem(window.constants.samples[2].id.toString(), 1, {}).then(async function (response) {
                    // console.log("addItem C199600392", response);
                    // return await _getCart();

                });
            }

            // sample | 1 Sep - 25 Oct
            // if (!doesCartHaveSample("C199600361")) {
                
            //     await _addItem(window.constants.samples[2].id.toString(), 1, {}).then(async function (response) {
            //         // console.log("addItem C108370010", response);
            //         // return await _getCart();
            //     });
            // }

            // console.log("calculateGwpTotal", gwpTotal);
        }

        await _checkForNeedEmptyCart(response).then(async function () {
            return await _getCart();
        });
        

    });

    return await _getCart();
}

// Add item to cart
window.addToCart = async function (variant, quantity, properties = {}) {
    return await _addItem(variant, quantity, properties);
}

window.getEnTranslations = async function () {
    return await _getGiftEnTranslations();
}